import { useEffect, useState } from "react";

import { DEFAULT_SORT, FIRST_DESCENDING, NO_FILTERS, type Filters, type Sort } from "../listing";

const SEARCH_DELAY_MS = 250;
const SORT_KEY = "knowledge-sort";

const readSort = (): Sort => {
  try {
    const saved = JSON.parse(localStorage.getItem(SORT_KEY) ?? "null");
    return saved && saved.key in FIRST_DESCENDING ? { key: saved.key, descending: !!saved.descending } : DEFAULT_SORT;
  } catch {
    return DEFAULT_SORT;
  }
};

export interface KbListing {
  /** What is typed; names match it at once. */
  query: string;
  /** The query once typing pauses: what the full-text search is asked. */
  term: string;
  filters: Filters;
  sort: Sort;
  setQuery: (query: string) => void;
  setFilters: (filters: Filters) => void;
  setSort: (sort: Sort) => void;
}

/* How the open base's table is narrowed and ordered. The search and the filters start
   over in another base; the sort is the reader's and is kept in this browser. */
export function useListing(kbId: string): KbListing {
  const [query, setQuery] = useState("");
  const [term, setTerm] = useState("");
  const [filters, setFilters] = useState<Filters>(NO_FILTERS);
  const [sort, setSortState] = useState<Sort>(readSort);

  useEffect(() => {
    setQuery("");
    setTerm("");
    setFilters(NO_FILTERS);
  }, [kbId]);
  useEffect(() => {
    const wait = setTimeout(() => setTerm(query.trim()), SEARCH_DELAY_MS);
    return () => clearTimeout(wait);
  }, [query]);

  const setSort = (next: Sort) => {
    setSortState(next);
    try { localStorage.setItem(SORT_KEY, JSON.stringify(next)); } catch { /* a private window keeps it for this visit */ }
  };
  return { query, term, filters, sort, setQuery, setFilters, setSort };
}
